
import React, { useEffect, Suspense } from "react";
import { useNavigate, useRoutes, type NavigateFunction } from "react-router-dom";
import routes from "./config";
import LoadingFallback from "../components/base/LoadingFallback";

let navigateResolver: ((navigate: ReturnType<typeof useNavigate>) => void) | null = null;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    if (navigateResolver) {
      navigateResolver(window.REACT_APP_NAVIGATE);
      navigateResolver = null;
    }
  }, [navigate]);

  return React.createElement(
    Suspense,
    { fallback: React.createElement(LoadingFallback) },
    element
  );
}
